import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class InfinityLogsIcon extends BaseIcon {
  getChildren = () => {
    return [
      <g id="Icons">
        <path fill={ this.getColor()}
              d="M17.76 12.36A4.75 4.75 0 0121.7 10a4.14 4.14 0 011.79.52A11.85 11.85 0 0021 6l-4.25 4.25a6 6 0 011.01 2.11zM11 2A12 12 0 000 14h6a6 6 0 015-6zM19.53 4.61A12 12 0 0013 2v6a6 6 0 012.24.86z"/>
        <path
            d="M23.61 16.39a4.71 4.71 0 01-3.87 2.85c-.21 0-.65 2.07-2.37 3.06-1.16.67-3.51 2.1-5.91-3.11-.42-.93-1.26-4.29 1.46-5.84 0 0 2.67-1.71 5.33 2.8 0 0 1-4.15 3.45-4.15.44 0 3.3.92 1.91 4.39zM18.26 18a15.85 15.85 0 00-2.38-2.25 6.72 6.72 0 00-2.22-1.41c-2.83 1.72.43 8.09 3.84 6.29.27-.13 1.06-2.12.76-2.63zm1.69-.5c1.11.08 2.53-2.37 2.42-3.15C20 14.26 20 17.51 20 17.51z"
            fillRule={'evenodd'} fill={ this.getColor()}/>
      </g>
    ]
  }
  getViewBox = () => '0 0 24 24'
}
